module.exports = __webpack_public_path__ + "static/media/cars.079a994c.svg";